import { buildModelManager } from "../builder.js";
const DefaultClinicalScenarioSelection = {
  __typename: true,
  id: true,
  ageBracket: true,
  ageRange: true,
  createdAt: true,
  createdById: true,
  description: { markdown: true, truncatedHTML: true },
  deteriorationVideoUrl: true,
  difficulty: true,
  ecgGenerationError: true,
  ecgGenerationStatus: true,
  ecgMetadata: true,
  essentialSkills: true,
  evaluationCohorts: true,
  generatedECG: { url: true, mimeType: true, fileName: true },
  improvementVideoUrl: true,
  institution: true,
  isActive: true,
  isPublic: true,
  levelOfCare: true,
  majorSystemInvolved: true,
  mechanismNatureOfInjury: true,
  mediaGenerationEnabled: true,
  mediaGenerationError: true,
  mediaGenerationMetadata: true,
  mediaGenerationStatus: true,
  patientImageUrl: true,
  scenarioOutput: true,
  sceneArrivalVideoUrl: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "clinicalScenario";
const pluralModelApiIdentifier = "clinicalScenarios";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalScenarioSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createClinicalScenario",
    operationReturnType: "CreateClinicalScenario",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      clinicalScenario: { required: false, type: "CreateClinicalScenarioInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalScenarioSelection
  },
  {
    type: "action",
    operationName: "bulkCreateClinicalScenarios",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateClinicalScenariosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalScenarioSelection
  },
  {
    type: "action",
    operationName: "updateClinicalScenario",
    operationReturnType: "UpdateClinicalScenario",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      clinicalScenario: { required: false, type: "UpdateClinicalScenarioInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalScenarioSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateClinicalScenarios",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateClinicalScenariosInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalScenarioSelection
  },
  {
    type: "action",
    operationName: "deleteClinicalScenario",
    operationReturnType: "DeleteClinicalScenario",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteClinicalScenarios",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertClinicalScenario",
    operationReturnType: "UpsertClinicalScenario",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      clinicalScenario: { required: false, type: "UpsertClinicalScenarioInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateClinicalScenarioResult": { hasReturnType: false },
      "... on UpdateClinicalScenarioResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalScenarioSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertClinicalScenarios",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertClinicalScenariosInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultClinicalScenarioSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "clinicalScenarioGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ClinicalScenarioManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultClinicalScenarioSelection,
  operations
);
export {
  ClinicalScenarioManager,
  DefaultClinicalScenarioSelection
};
//# sourceMappingURL=ClinicalScenario.js.map
